<template>
  <zl-dialog class="zl-saas" title="提示" ref="dialog" width="480px" :close-on-click-modal="false">
    <div class="gys-tip-box">
      <el-form
        :model="form"
        ref="form"
      >
        <el-form-item label="拒绝原因：" prop="reason" :rules="[{required: true, message: '请输入拒绝原因'}]">
          <el-input v-model="form.reason" placeholder="请输入拒绝原因" maxlength="200" type="textarea" rows="4"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <template slot="footer">
      <el-button size="small" plain type="primary" @click="cancel">
        取消
      </el-button>
      <el-button size="small" type="primary" @click="confirm">确认</el-button>
    </template>
  </zl-dialog>
</template>
<script>
// import store from '@/store'
export default {
  data() {
    return {
      form: {
        reason: '' // 拒绝原因
      }
      // orderId: '' // 订单ID
    }
  },
  methods: {
    open(args) {
      // this.orderId = args.orderId
      return this.$refs.dialog.open()
    },
    cancel() {
      this.$refs.dialog.cancel()
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$refs.dialog.close(this.form.reason)
        }
      })
    }
  }
}
</script>
<style lang="scss">

</style>
